import { LocalStorageHelper } from "@travellocal/utils/localStorageHelper";

/**
 * Populate a state from local storage if an empty state is passed in
 */
export const initialiseState = <T>(cacheKey: string, parse: (item: string|null) => T) => {
  return (state: IState<T>, action: IStoreAction<any>): IState<T> => {
    if (state != null) {
      return state;
    }

    let dataString = LocalStorageHelper.getItem(cacheKey);
    if (dataString == undefined) {
      dataString = null;
    }

    return {
      status: "OK",
      data: parse(dataString),
      context: {
        from: "local storage"
      }
    };
  }
}

/**
 * Serialises a state into a local storage key
 */
export const serialiseState = <T>(cacheKey: string, serialise: (item: T) => string|null) => {
  return (state: IState<T>, action: IStoreAction<any>) => {
    if (state && state.status == "OK") {
      let dataString = serialise(state.data);
      if (dataString != null) {
        LocalStorageHelper.setItem(cacheKey, dataString);
      }
      else {
        LocalStorageHelper.removeItem(cacheKey);
      }
    }

    return state;
  }
}
